import React from 'react';
import { useConsent } from '../contexts/ConsentContext';
import './CookieBanner.css';

const CookieBanner = () => {
  const { 
    isBannerVisible, 
    acceptAll, 
    acceptNecessary, 
    openSettings 
  } = useConsent();

  if (!isBannerVisible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <h3>We use cookies</h3>
          <p>
            We use cookies to enhance your browsing experience, serve personalized content, 
            and analyze our traffic. By clicking "Accept All", you consent to our use of cookies. 
            You can manage your preferences in Cookie Settings.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button 
            className="cookie-btn cookie-btn-secondary" 
            onClick={acceptNecessary}
          >
            Necessary Only
          </button>
          <button 
            className="cookie-btn cookie-btn-settings" 
            onClick={openSettings}
          >
            Cookie Settings
          </button>
          <button 
            className="cookie-btn cookie-btn-primary" 
            onClick={acceptAll}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
